import getWindow from 'unified-navigation-ui/js/utils/getWindow';
export const addParamsToUrl = (url, params) => {
  const urlParams = new URLSearchParams(url);
  Object.entries(params).forEach(([key, value]) => {
    urlParams.set(key, value);
  });
  return `${url}?${urlParams.toString()}`;
};
export const getInAppHelpQueryParams = (reopened, shouldUsePersistentRoute) => {
  var _currentWindow$hubspo;
  const currentWindow = getWindow();
  const appName = (_currentWindow$hubspo = currentWindow.hubspot) === null || _currentWindow$hubspo === void 0 || (_currentWindow$hubspo = _currentWindow$hubspo.bender) === null || _currentWindow$hubspo === void 0 ? void 0 : _currentWindow$hubspo.currentProject;
  return Object.assign({
    // Used by in-app-help-ui/static/js/components/NavComponentFunctions/NavComponentFunctions.utils.ts
    // to determine if the widget should redirect to the persistent route
    shouldUsePersistentRoute: shouldUsePersistentRoute ? 'true' : 'false',
    href: currentWindow.location.href,
    appName,
    title: currentWindow.document.title,
    pathname: currentWindow.location.pathname
  }, reopened && {
    reopen: 'true'
  });
};